import apiClient from './client';

export interface Activity {
  id: number;
  lead_id?: number;
  account_id?: number;
  contact_id?: number;
  type: string;
  subject: string;
  description?: string;
  created_by: number;
  created_at: string;
}

export interface ActivitiesResponse {
  success: boolean;
  data: Activity[];
}

export const activitiesApi = {
  getAll: async (): Promise<Activity[]> => {
    const response = await apiClient.get<ActivitiesResponse>('/activities');
    return response.data.data;
  },
  create: async (activity: Partial<Activity>): Promise<Activity> => {
    const response = await apiClient.post<{ success: boolean; data: Activity }>('/activities', activity);
    return response.data.data;
  },
  update: async (id: number, activity: Partial<Activity>): Promise<Activity> => {
    const response = await apiClient.patch<{ success: boolean; data: Activity }>(`/activities/${id}`, activity);
    return response.data.data;
  },
  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/activities/${id}`);
  },
};

